<template>
  <div class="text-left">
    <div class="row">
      <div class="col-lg-2 mb-2">
        <button class="btn btn-info col" @click="openModalAdd()">
          Criar nova agenda
          <font-awesome-icon icon="plus" class="pointer" />
        </button>
      </div>
      <div class="col-lg-2 mb-2">
        <button class="btn btn-danger col" @click="onDelete()">
          Remover
          <font-awesome-icon icon="trash" class="pointer" />
        </button>
      </div>
    </div>
    <div class="row">
      <div class="alert col alert-warning col mt-3" v-if="lista.length == 0">
        <strong>Atenção!</strong> Nenhuma mensagem encontrada
      </div>
    </div>

    <div class="page-data">
      <div class="row">
        <div class="col">
          <table class="table table-dark table-striped table-sm">
            <thead class="thead-dark">
              <tr>
                <th scope="col">
                  <b-form-checkbox v-model="selectAllStatus" @change="selectAll()"></b-form-checkbox>
                </th>
                <th scope="col">Mensagem</th>
                <th scope="col">Opção</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="msg in lista" :key="msg._id">
                <td>
                  <b-form-checkbox v-model="msg.selected"></b-form-checkbox>
                </td>
                <td>{{msg.mensagem}}</td>
                <td>
                  <button class="btn btn-info mr-2 btn-sm" @click="openModalAdd(msg)">
                    <font-awesome-icon icon="edit" class="pointer" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <my-pagination :total="totalItens" @pageChanged="listAll($event.skip,$event.limit)"></my-pagination>
    </div>
  </div>
</template>

<script>
import jwtDecode from "jwt-decode";
import moment from "moment";
import Form from "./Form";

export default {
  data() {
    return {
      lista: [],
      totalItens: 0,
      form: {},
      skip: 0,
      limit: 8,
      search: "",
      selectAllStatus: false
    };
  },
  methods: {
    selectAll() {
      for (let i = 0; i < this.lista.length; i++) {
        const el = this.lista[i];
        el.selected = !this.selectAllStatus;
      }
    },
    openModalAdd(editObj) {
      this.$modal.show(
        Form,
        {
          mensagem: editObj ? editObj : false
        },
        {
          adaptive: true,
          height: "auto",
          scrollable: true
        },
        {
          closed: () => {
            this.listAll();
          }
        }
      );
    },
    async onDelete() {
      if (confirm("Tem certeza que deseja remover todos os selecionados?")) {
        for (let i = 0; i < this.lista.length; i++) {
          for (let i = 0; i < this.lista.length; i++) {
            const el = this.lista[i];
            if (el.selected) {
              await this.$http.delete(`/v1/v3/mensagens-pre/${el._id}`);
            }
          }
          this.listAll();
        }
      }
    },
    async listAll(skip, limit) {
      skip = skip ? skip : this.skip;
      limit = limit ? limit : this.limit;

      let response = await this.$http.get(
        `/v1/v3/mensagens-pre/${skip}/${limit}`
      );
      if (response.data) {
        this.lista = response.data;
        this.totalItens = response.total;
      }
    }
  },
  async mounted() {
    this.listAll();
  }
};
</script>